import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=28253896&scoped=true&"
var script = {}
import style0 from "./Layout.vue?vue&type=style&index=0&id=28253896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28253896",
  null
  
)

export default component.exports